import styled, { css } from 'styled-components';
import { TextField, Box, BoxProps } from '@bechtel/gds';
import { FC } from 'react';

export const EditBarStyled = styled(Box)`
  height: 100%;
  ${({ theme }) =>
    css`
      width: ${theme.spacings[300]};
      background-color: ${theme.colors.bechtel.blue[300]};
      border-top-left-radius: ${theme.radii[200]};
      border-bottom-left-radius: ${theme.radii[200]};
    `}
`;

export const TextInputStyled = styled(TextField)`
  ${({ theme }) =>
    css`
      font-size: ${theme.fontSizes[400]};
      font-family: ${theme.fontFamilies['graphik']};
      color: ${theme.colors.grey[1000]};
    `}
`;

interface ItemStyledProps extends BoxProps {
  isActive: boolean;
}

export const ItemStyled = styled(Box as FC<ItemStyledProps>)`
  ${({ theme, isActive }) =>
    css`
      border-bottom: 1px solid ${theme.colors.grey[300]};
      ${!isActive && `background-color:${theme.colors.grey[100]}`}
    `}
`;

export const EditItemStyled = styled(Box)`
  ${({ theme }) =>
    css`
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      border: solid 1px ${theme.colors.grey[300]};
      border-radius: ${theme.radii[200]};
      border-left: 0;
      flex-direction: column;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      border-left: 0;
    `}
`;

export const EditReportContainerStyled = styled(Box)`
  flex-direction: column;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border-left: 0;
  ${({ theme }) =>
    css`
      padding: ${theme.spacings[500]} ${theme.spacings[400]};
      border: solid 1px ${theme.colors.grey[300]};
      border-left: ${theme.spacings[300]} solid ${theme.colors.bechtel.blue[300]};
      border-radius: ${theme.radii[300]};
    `}
`;
